<template>
    <div class="qrcode">
        <div class="qrcode-logo">
            <img src="@/images/temporary/logo.png" alt="logo">
        </div>
        <div class="qrcode-bg">
            <div class="qrcode-area">
                <div class="qrcode-form">
                    <div class="item-qrcode">
                        <qrcode-vue :value="qrcodeValue" size="300" level="M"></qrcode-vue>
                        <div class="item-cover" v-if="showExpire">
                            <div @click="refresh">
                                <Icon type="md-refresh" size="60" class="icon" color="#747474"/>
                            </div>
                        </div>
                    </div>
                    <p>{{remark}}</p>
                </div>
            </div>
        </div>
        <div class="qrcode-footer">
            <p>Copyright ©</p>
            <p>{{$t('companyName')}}</p>
            <p>{{$t('icp')}}</p>
        </div>
    </div>
</template>
<script>
import QrcodeVue from 'qrcode.vue';
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';
export default {
    components: {
        QrcodeVue
    },
    data() {
        return {
            code: this.$route.params.code,
            qrcodeValue: '',
            showExpire: false, //显示遮罩层
            remark: this.$t('a_waitReview')
        };
    },
    mounted() {
        this.getQrcode();
    },
    methods: {
        //获取二维码
        getQrcode() {
            return Axios.get(AxiosUrl.user.qrcode, {
                params: {
                    uid: this.code
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.qrcodeValue = res.data.data;
                    this.access();
                } else {
                    console.log(res.data.msg);
                }
            });
        },
        //监测是否审核
        access() {
            Axios.get(AxiosUrl.user.accessstatus, {
                params: {
                    token: this.qrcodeValue,
                    uid: this.code
                }
            }).then(res => {
                if (res.data.code == 200) {
                    var user = JSON.parse(sessionStorage.getItem('user'));
                    user.cid = res.data.data;
                    //存储
                    sessionStorage.setItem('user', JSON.stringify(user)); // json序列化存储用户登录信息
                    sessionStorage.setItem('time', new Date().getTime() / 1000);
                    this.$store.commit('upUser', user);
                    // 跳转到home
                    this.$router.push('home');
                } else if (res.data.code == 401) {
                    this.showExpire = true;
                    this.remark = this.$t('a_qrcodeOver');
                } else if (res.data.code == 400) {
                    this.access();
                } else {
                    console.log(res.data.msg);
                }
            });
        },
        //刷新二维码
        refresh() {
            this.getQrcode();
            this.showExpire = false;
            this.remark = this.$t('a_waitReview');
        }
    }
};
</script>
<style lang="less">
.qrcode {
    position: relative;
    height: 100%;
    .qrcode-logo {
        position: absolute;
        top: 45px;
        left: 50px;
        width: 250px;
    }
    .qrcode-bg {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        background-color: #009dd0;
        background-image: -webkit-linear-gradient(left, #07aa9b, #009dd0);
        background-image: linear-gradient(to right, #07aa9b, #009dd0);
        background-repeat: no-repeat;
        .qrcode-area {
            margin-top: -100px;
            // box-shadow: 1px 2px 15px rgba(0, 0, 0, 0.1);
            .qrcode-form {
                .item-qrcode {
                    padding: 30px;
                    background-color: white;
                    box-shadow: 0 0 8px #666;
                    border-radius: 3px;
                    position: relative;
                    .item-cover {
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 0;
                        bottom: 0;
                        border-radius: 3px;
                        background-color: rgba(255, 255, 255, 0.9);
                        display: flex;
                        div {
                            width: 100px;
                            height: 100px;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            margin-left: -50px;
                            margin-top: -50px;
                            background-color: #fff;
                            border-radius: 50%;
                            box-shadow: 1px 2px 15px rgba(0, 0, 0, 0.3);
                            cursor: pointer;
                            .icon {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                margin-left: -30px;
                                margin-top: -30px;
                            }
                        }
                    }
                }
                p {
                    color: #ffffff;
                    font-size: 16px;
                    padding-top: 30px;
                    text-align: center;
                }
            }
        }
    }
    .qrcode-footer {
        position: absolute;
        bottom: 15px;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        p {
            color: white;
            font-size: 14px;
            padding-left: 26px;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/qrcode/qrcode.vue